/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaymentMethodResponse } from '../../models/payment-method-response';

export interface GetPaymentMethods$Params {
}

export function getPaymentMethods(http: HttpClient, rootUrl: string, params?: GetPaymentMethods$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PaymentMethodResponse>>> {
  const rb = new RequestBuilder(rootUrl, getPaymentMethods.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PaymentMethodResponse>>;
    })
  );
}

getPaymentMethods.PATH = '/payment-methods';
